import React, { useState } from 'react';
import './LoginPage.styled.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import md5 from 'blueimp-md5'; // ✅ hash MD5 từ client

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [entryMode, setEntryMode] = useState('choose'); // 'choose' | 'employer'
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const hashedPassword = md5(password); // ✅ hash md5 trước khi gửi
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/login`,
        {
          username,
          password: hashedPassword,
        },
        { withCredentials: true }
      );

      if (response.data.message === 'Login successful') {
        navigate('/jobs');
      } else {
        setErrorMsg('Invalid username or password');
      }
    } catch (err) {
      setErrorMsg('Invalid username or password');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  if (entryMode === 'choose') {
    return (
      <div className="entry-container">
        <div className="entry-card-wrap">
          <div className="entry-title">
            <div className="entry-brand">CVrify</div>
          </div>

          <div className="entry-grid">
            <button
              className="entry-card entry-card--primary"
              onClick={() => navigate('/candidate')}
              type="button"
            >
              <div className="entry-card-title">For Job Applicant</div>
              <div className="entry-card-desc">
                Enter your application code, verify test status, then start.
              </div>
            </button>

            <button
              className="entry-card entry-card--secondary"
              onClick={() => setEntryMode('employer')}
              type="button"
            >
              <div className="entry-card-title">For Employer</div>
              <div className="entry-card-desc">
                Login to manage Jobs, CV screening, and candidate tests.
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div>
        <div className="login-backline">
          <button className="login-back" onClick={() => setEntryMode('choose')} type="button">
            ← Back
          </button>
        </div>

        <h2>Login</h2>
        <input
          className="login-input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          onKeyDown={handleKeyDown}
        />
        <div className="password-wrapper">
          <input
            className="login-input"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            onKeyDown={handleKeyDown}
          />
          <button
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
            type="button"
          >
            {showPassword ? '🙈' : '👁️'}
          </button>
        </div>
        {errorMsg && <div className="error-message">{errorMsg}</div>}
        <button className="login-button" onClick={handleLogin}>Login</button>
      </div>
    </div>
  );
};

export default LoginPage;
